import {
  createListStrategy,
  type DynamicComponent,
  type ListStrategyFactoryOptions
} from '@dec/shared';
import { useGetGlobalTaxReturnValues } from 'app/modules/FormDefinition/services/signalr.hooks';

import { useCatalogValueList } from '@/app/modules/configuration/catalogs/hooks/useCatalogValueList';

import { ObjectRequired } from '../../../../../../core/validations/common';
import { ChangeComponent } from '../../../ChangeComponent';

const options: ListStrategyFactoryOptions = {
  ChangeComponent,
  requiredValidation: ObjectRequired,
  useCatalogList: useCatalogValueList,
  useRuntime: useGetGlobalTaxReturnValues
};

export default createListStrategy(options) as DynamicComponent;
